export default __webpack_public_path__ + "static/nhs-employers-3862be33fa5dc1cae87a329f6c7c9a36.png";